import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Lightbox from "react-18-image-lightbox";
import { Box, CircularProgress } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

import Events from "./events";
import { useAppDispatch } from "../redux/hook";
import { fetchEventEdit } from "../redux/actions/eventAction";

import "react-18-image-lightbox/style.css";

export default function EventDetail({ id }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [isOpen, setisOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [eventData, setEventData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id > 0) {
      const loadEvent = async () => {
        const event = await dispatch(fetchEventEdit({ id }));
        if (typeof event.payload === "string" || event.payload === undefined) {
          setLoading(false);
        } else {
          setLoading(false);
          setEventData(event.payload);
        }
      };
      loadEvent();
    } else {
      setLoading(false);
    }
  }, [dispatch, id]);

  const images = [
    process.env.REACT_APP_API_URL + "/wwwroot/images/" + eventData?.image_file,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_02,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_03,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_04,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_05,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_06,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_07,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_08,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_09,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_10,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_11,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_12,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_13,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_14,
    process.env.REACT_APP_API_URL +
      "/wwwroot/images/" +
      eventData?.image_file_15,
  ];

  const handleMovePrev = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + images.length - 1) % images.length
    );
  };

  const handleMoveNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setisOpen(true);
  };

  const currentImage = images[currentImageIndex];

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return id > 0 ? (
    <>
      <div className="relative">
        <div className="shape absolute sm:-bottom-px -bottom-[2px] start-0 end-0 overflow-hidden z-1 text-white dark:text-slate-900">
          <svg
            className="w-full h-auto scale-[2.0] origin-top"
            viewBox="0 0 2880 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
      <section className="relative md:py-24 py-16">
        <div className="container relative">
          <div className="grid md:grid-cols-12 grid-cols-1 gap-6">
            <div className="lg:col-span-8 md:col-span-7">
              <div id="grid" className="">
                <ResponsiveMasonry
                  columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
                >
                  <Masonry>
                    <div className="picture-item p-1" key={0}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(0)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={1}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(1)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_02
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={2}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(2)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_03
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={3}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(3)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_04
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={4}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(4)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_05
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={5}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(5)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_06
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={6}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(6)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_07
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={7}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(7)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_08
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={8}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(8)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_09
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={9}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(9)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_10
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={10}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(10)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_11
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={11}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(11)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_12
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={12}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(12)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_13
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={13}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(13)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_14
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                    <div className="picture-item p-1" key={14}>
                      <div className="group relative block overflow-hidden rounded-xl duration-500">
                        <Link
                          href=""
                          onClick={() => handleImageClick(14)}
                          className="lightbox duration-500 group-hover:scale-105"
                          title=""
                        >
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              "/wwwroot/images/" +
                              eventData?.image_file_15
                            }
                            className=""
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </Masonry>
                </ResponsiveMasonry>
              </div>
              {isOpen && (
                <Lightbox
                  mainSrc={currentImage}
                  prevSrc={
                    images[
                      (currentImageIndex + images.length - 1) % images.length
                    ]
                  }
                  nextSrc={images[(currentImageIndex + 1) % images.length]}
                  onCloseRequest={() => setisOpen(false)}
                  onMovePrevRequest={handleMovePrev}
                  onMoveNextRequest={handleMoveNext}
                />
              )}

              <div className="flex mt-6">
                <div className="w-full">
                  <h4 className="text-3xl leading-normal font-semibold mb-6">
                    {t("external.event.event_description")}
                  </h4>
                  <p className="text-slate-400 dark:text-white/60">
                    {eventData?.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-4 md:col-span-5">
              <div className="sticky top-20">
                <h5 className="text-lg font-semibold bg-gray-50 dark:bg-slate-800 shadow dark:shadow-gray-800 rounded-xl p-2 text-center">
                  {t("external.event.event_info")} :
                </h5>
                <dl className="grid grid-cols-12 mb-0 mt-4">
                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.event.name")} :
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {eventData?.name}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.event.description")} :
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {eventData?.description}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.event.price")} :
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {eventData?.price}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.event.start_date")} :
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {moment(eventData?.start_date)?.format("DD/MM/YYYY")}
                  </dd>

                  <dt className="md:col-span-4 col-span-5 mt-2">
                    {t("external.event.start_time")} :
                  </dt>
                  <dd className="md:col-span-8 col-span-7 mt-2 text-slate-400">
                    {eventData?.start_time}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  ) : (
    <Events />
  );
}
